import i18n from '@/vueI18n';

export interface IGenericGeofenceTypeCountryAPI {
  country_code: string;
  geofence_type: string;
}
export default class GenericGeofenceTypeCountry {
  countryCode: string;

  geofenceType: string;

  constructor(countryCode: string, geofenceType: string) {
    this.countryCode = countryCode;
    this.geofenceType = geofenceType;
  }

  get name(): string {
    return i18n.global.t(`options.genericGeofenceTypes.${this.geofenceType}`);
  }

  static fromApi(apiObject: IGenericGeofenceTypeCountryAPI): GenericGeofenceTypeCountry {
    return new GenericGeofenceTypeCountry(apiObject.country_code, apiObject.geofence_type);
  }
}
